import React, { useState } from "react";
import './banner.scss';
import usePoolCounts from '../../../hooks/usePoolCounts';
import useWallet from '../../../hooks/useWallet';
import { useGlobalStats } from '../../../hooks/useGlobalStats';
import Stats from './Stats';
import { useTheme } from '../../../hooks/ThemeProvider';
import { Link } from 'react-router-dom';
import useFarms from '../farms/hooks/useFarms';
import { Toast, ToastContainer } from "react-bootstrap";

const Banner = () => {
  // notifySuccess("error msg")
  const { theme } = useTheme();
  const { address } = useWallet();

  // const { address } = useWallet();
  const { data, loading, error, refetch } = useGlobalStats({ first: 1000 });
  let poolCounts = 1000
  const {
    searchValue,
    sortBy,
    rootPools,
    loader,
    currentPage,
    perPage,
    totalItems,
    handleSearchChange,
    handleSortChange,
    handlePageChange,
    handlePerPageChange
  } = useFarms(poolCounts);
  const [showprofile, setShowProfile] = useState(false);
  const toggleShowProfile = () => setShowProfile(!showprofile);
  return (
    <>
      <section className='main_banner' >
        {
          theme === 'dark' ? <img src='\assets\bannershade.png' className='bannershade' />
            : <img src='\assets\whiteshade.png' className='bannershade' />
        }
        <div className='custom-container'>
          <div className='inner_banner'>
            <div className='top_side'>

              <h2>Make Staking <br /> Social Again.</h2>
              <p>Empowers Web3 projects to build decentralized, community-driven staking networks. Its social, multi-layered model connects projects and users, driving liquidity, transparency, and engagement while optimizing yield and organic growth through collective participation.</p>
              <Link to='/childpool'> <button>Start Earning Now</button></Link>
            </div>
            <Stats data={data} rootPools={rootPools} />
          </div>
        </div>

      </section>








      {/* //      toast messages      // */}
      <div className="custom-container">
        <ToastContainer position="top-end" className="green-toast p-3">

          <Toast
            show={showprofile}
            onClose={toggleShowProfile}
            className="custom-toast"
            autohide
            delay={5000}

          >
            {
              theme === 'dark' ? <svg className="svgcrooss" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect width="16" height="16" rx="8" fill="#0F1F41" />
                <path d="M10.6666 5.33337L5.33325 10.6667" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.33325 5.33337L10.6666 10.6667" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
                : <svg className="svgcrooss" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect width="16" height="16" rx="8" fill="#E4E6EC" />
                  <path d="M10.6668 5.33337L5.3335 10.6667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.3335 5.33337L10.6668 10.6667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            }
            <Toast.Body className="custom-toast-body">

              <img
                src="\assets\error.svg"
                alt="img"
                className="img-fluid"
              />
              <div className="text-inside">
                <h6>Error Message</h6>
                <p>Error toast message appear here</p>
              </div>
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      <div className="custom-container">
        <ToastContainer position="top-end" className="warning-toast p-3">

          <Toast
            show={showprofile}
            onClose={toggleShowProfile}
            className="custom-toast-warning"
            autohide
            delay={500}

          >
            {
              theme === 'dark' ? <svg className="svgcrooss" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect width="16" height="16" rx="8" fill="#0F1F41" />
                <path d="M10.6666 5.33337L5.33325 10.6667" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.33325 5.33337L10.6666 10.6667" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
                : <svg className="svgcrooss" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect width="16" height="16" rx="8" fill="#E4E6EC" />
                  <path d="M10.6668 5.33337L5.3335 10.6667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.3335 5.33337L10.6668 10.6667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            }
            <Toast.Body className="custom-toast-body">

              <img
                src="\assets\warning.svg"
                alt="img"
                className="img-fluid"
              />
              <div className="text-inside">
                <h6>Warning Message</h6>
                <p>Warning toast message appear here</p>
              </div>
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      <div className="custom-container">
        <ToastContainer position="top-end" className="info-toast p-3">

          <Toast
            show={showprofile}
            onClose={toggleShowProfile}
            className="custom-toast-warning"
            autohide
            delay={5000}

          >
            {
              theme === 'dark' ? <svg className="svgcrooss" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect width="16" height="16" rx="8" fill="#0F1F41" />
                <path d="M10.6666 5.33337L5.33325 10.6667" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.33325 5.33337L10.6666 10.6667" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
                : <svg className="svgcrooss" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect width="16" height="16" rx="8" fill="#E4E6EC" />
                  <path d="M10.6668 5.33337L5.3335 10.6667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.3335 5.33337L10.6668 10.6667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            }
            <Toast.Body className="custom-toast-body">

              <img
                src="\assets\info.svg"
                alt="img"
                className="img-fluid"
              />
              <div className="text-inside">
                <h6>Info Message</h6>
                <p>Info toast message appear here</p>
              </div>
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      <div className="custom-container">
        <ToastContainer position="top-end" className="success-toast p-3">

          <Toast
            show={showprofile}
            onClose={toggleShowProfile}
            className="custom-toast-warning"
            autohide
            delay={5000}

          >
            {
              theme === 'dark' ? <svg className="svgcrooss" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect width="16" height="16" rx="8" fill="#0F1F41" />
                <path d="M10.6666 5.33337L5.33325 10.6667" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.33325 5.33337L10.6666 10.6667" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
                : <svg className="svgcrooss" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect width="16" height="16" rx="8" fill="#E4E6EC" />
                  <path d="M10.6668 5.33337L5.3335 10.6667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.3335 5.33337L10.6668 10.6667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            }

            <Toast.Body className="custom-toast-body">

              <img
                src="\assets\success.svg"
                alt="img"
                className="img-fluid"
              />
              <div className="text-inside">
                <h6>Success Message</h6>
                <p>Success toast message appear here</p>
              </div>
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>

  )
}

export default Banner
